import type { IteroOrder } from '../../../../../services/iteroBrowse';
import { orEmpty, type DetailFormatters } from '../iteroBrowseFormat.ts';

const BACK_TO_PATIENT_LABEL = 'Patient';

export interface OrderContext {
    // Null when the order was opened straight from the Orders table: there is no patient to return to.
    backLabel: string | null;
    title: string;
}

export function orderContext(
    order: IteroOrder,
    format: DetailFormatters,
    fromPatient: boolean
): OrderContext {
    const procedure = orEmpty(order.procedureName) ?? orEmpty(order.procedureTypeName);
    const parts = [procedure, orEmpty(format.shortDate(order.scanningDate))].filter(
        (part): part is string => part !== null
    );
    return {
        backLabel: fromPatient ? BACK_TO_PATIENT_LABEL : null,
        title: parts.length > 0 ? parts.join(' · ') : `Order ${order.orderCode}`
    };
}
